import { api } from "./api";

export const apiPaymentRequest = {
  getPaymentRequest: (params) => {
    return api.get("web/payment_requests/", params);
  },

  exportPaymentRequest: (filter, fileName = "Payment request") =>
    api.getExcel("web/export/payment_request", { filter, fileName }),

  sentPaymentRequestToCustomer: (filter) =>
    api.post("web/payment_requests/export_to_customer", filter),

  getPaymentRequestDriverless: (params) => {
    return api.get("web/payment_requests/with_out_driver", params);
  },

  exportPaymentRequestDriverless: (filter, fileName = "Payment request") =>
    api.getExcel("web/export/payment_request_without_driver", {
      filter,
      fileName,
    }),
};
